import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';
import { getReportStatsSelector } from '../reports.reducer';
import { Stats } from '../../stats/stats.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'cc-report-stats',
  templateUrl: './report-stats.component.html',
  styleUrls: ['./report-stats.component.scss']
})
export class ReportStatsComponent implements OnInit {
  public stats$: Observable<Stats>;

  constructor(private store: Store<IState>) {}

  ngOnInit() {
    this.stats$ = this.store.select(getReportStatsSelector);
  }
}
